export default "__VITE_ASSET__Y4kPv5f2__"